import { render, staticRenderFns } from "./PlansSidebar.vue?vue&type=template&id=2ef14bdf&scoped=true"
import script from "./PlansSidebar.vue?vue&type=script&lang=js"
export * from "./PlansSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef14bdf",
  null
  
)

export default component.exports